import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const ShortCoursesPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=2072&q=80",
    heading: "Web Design",
    introduction: "Learn modern web design principles, HTML, CSS, and responsive design techniques.",
    buttonText: "LEARN MORE",
    route: "web-design",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "System Maintenance and Repair: With CISCO",
    introduction: "Master computer system maintenance, troubleshooting, and CISCO networking fundamentals.",
    buttonText: "LEARN MORE",
    route: "system-maintenance-cisco",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Computer Hardware",
    introduction: "Learn computer hardware components, assembly, and troubleshooting techniques.",
    buttonText: "LEARN MORE",
    route: "computer-hardware",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=2072&q=80",
    heading: "Networking: With CISCO Course",
    introduction: "Master network design, implementation, and CISCO networking technologies.",
    buttonText: "LEARN MORE",
    route: "networking-cisco",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Basic Electronics And Repair",
    introduction: "Learn electronic components, circuits, and repair techniques for electronic devices.",
    buttonText: "LEARN MORE",
    route: "basic-electronics-repair",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1626785774573-4b7992813457?auto=format&fit=crop&w=2072&q=80",
    heading: "Graphics Design",
    introduction: "Master graphic design principles, Adobe Creative Suite, and visual communication.",
    buttonText: "LEARN MORE",
    route: "graphics-design",
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1434030216411-0b793b4c2810?auto=format&fit=crop&w=2072&q=80",
    heading: "English: With CISCO Course",
    introduction: "Improve English language skills with CISCO certification preparation.",
    buttonText: "LEARN MORE",
    route: "english-cisco",
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?auto=format&fit=crop&w=2072&q=80",
    heading: "Python: With CISCO Python Essentials",
    introduction: "Learn Python programming fundamentals and CISCO Python Essentials certification.",
    buttonText: "LEARN MORE",
    route: "python-cisco-essentials",
  },
  {
    id: 9,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Basic Computer: ITF(With CISCO OS and IT)",
    introduction: "Master basic computer skills and CISCO IT Fundamentals certification.",
    buttonText: "LEARN MORE",
    route: "basic-computer-itf-cisco",
  },
  {
    id: 10,
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=2072&q=80",
    heading: "Digital Marketing",
    introduction: "Learn digital marketing strategies, social media, and online advertising techniques.",
    buttonText: "LEARN MORE",
    route: "digital-marketing",
  },
  {
    id: 11,
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e6e9c?auto=format&fit=crop&w=2072&q=80",
    heading: "Mobile Applications",
    introduction: "Develop mobile apps for iOS and Android platforms using modern frameworks.",
    buttonText: "LEARN MORE",
    route: "mobile-applications",
  },
  {
    id: 12,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "CCTV Camera",
    introduction: "Learn CCTV system installation, configuration, and surveillance techniques.",
    buttonText: "LEARN MORE",
    route: "cctv-camera",
  },
  {
    id: 13,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Mobile Repair",
    introduction: "Master smartphone and tablet repair techniques and troubleshooting.",
    buttonText: "LEARN MORE",
    route: "mobile-repair",
  },
  {
    id: 14,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=2072&q=80",
    heading: "TALLY",
    introduction: "Learn TALLY accounting software for business financial management.",
    buttonText: "LEARN MORE",
    route: "tally",
  },
  {
    id: 15,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=2072&q=80",
    heading: "QUICK BOOK",
    introduction: "Master QuickBooks accounting software for small business management.",
    buttonText: "LEARN MORE",
    route: "quick-book",
  },
  {
    id: 16,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=2072&q=80",
    heading: "Entrepreneurship",
    introduction: "Learn business planning, startup strategies, and entrepreneurial skills.",
    buttonText: "LEARN MORE",
    route: "entrepreneurship",
  },
  {
    id: 17,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2072&q=80",
    heading: "Procurement & Supply",
    introduction: "Master procurement processes, supply chain management, and vendor relations.",
    buttonText: "LEARN MORE",
    route: "procurement-supply",
  },
  {
    id: 18,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=2072&q=80",
    heading: "Basic Account",
    introduction: "Learn fundamental accounting principles and bookkeeping practices.",
    buttonText: "LEARN MORE",
    route: "basic-account",
  },
  {
    id: 19,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=2072&q=80",
    heading: "Advance EXCEL",
    introduction: "Master advanced Excel functions, data analysis, and automation techniques.",
    buttonText: "LEARN MORE",
    route: "advance-excel",
  },
  {
    id: 20,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "MCSA(Microsoft Certified Solution)",
    introduction: "Prepare for Microsoft Certified Solutions Associate certification exams.",
    buttonText: "LEARN MORE",
    route: "mcsa-microsoft-certified",
  },
  {
    id: 21,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "ARDUINO Programming",
    introduction: "Learn Arduino microcontroller programming and IoT project development.",
    buttonText: "LEARN MORE",
    route: "arduino-programming",
  },
  {
    id: 22,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Photocopy and Printer Repair",
    introduction: "Master photocopier and printer maintenance, repair, and troubleshooting.",
    buttonText: "LEARN MORE",
    route: "photocopy-printer-repair",
  },
  {
    id: 23,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=2072&q=80",
    heading: "CISCO Courses",
    introduction: "Comprehensive CISCO networking and IT certification preparation courses.",
    buttonText: "LEARN MORE",
    route: "cisco-courses",
  },
  {
    id: 24,
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=2072&q=80",
    heading: "Data Science; Data Analytics Essentials",
    introduction: "Learn data science fundamentals, analytics, and visualization techniques.",
    buttonText: "LEARN MORE",
    route: "data-science-analytics",
  },
  {
    id: 25,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Operating Systems and Information Technology",
    introduction: "Master operating systems, IT fundamentals, and system administration.",
    buttonText: "LEARN MORE",
    route: "operating-systems-it",
  },
  {
    id: 26,
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=2072&q=80",
    heading: "Introduction to Cybersecurity",
    introduction: "Learn cybersecurity fundamentals, threats, and protection strategies.",
    buttonText: "LEARN MORE",
    route: "introduction-cybersecurity",
  },
  {
    id: 27,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Introduction to IoT",
    introduction: "Explore Internet of Things concepts, devices, and smart technology applications.",
    buttonText: "LEARN MORE",
    route: "introduction-iot",
  },
  {
    id: 28,
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=2072&q=80",
    heading: "Ethical Hackers",
    introduction: "Learn ethical hacking techniques, penetration testing, and security assessment.",
    buttonText: "LEARN MORE",
    route: "ethical-hackers",
  },
  {
    id: 29,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=2072&q=80",
    heading: "CompTIA Courses",
    introduction: "Prepare for CompTIA IT certifications including A+, Network+, and Security+.",
    buttonText: "LEARN MORE",
    route: "comptia-courses",
  },
  {
    id: 30,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "IT Operations Specialist",
    introduction: "Master IT operations, system administration, and infrastructure management.",
    buttonText: "LEARN MORE",
    route: "it-operations-specialist",
  },
  {
    id: 31,
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=2072&q=80",
    heading: "NETWORK +",
    introduction: "Prepare for CompTIA Network+ certification and advanced networking skills.",
    buttonText: "LEARN MORE",
    route: "network-plus",
  },
  {
    id: 32,
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=2072&q=80",
    heading: "Secure Infrastructure Specialist",
    introduction: "Learn secure infrastructure design, implementation, and management practices.",
    buttonText: "LEARN MORE",
    route: "secure-infrastructure-specialist",
  },
];

const ShortCoursesProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={ShortCoursesPrograms}
        basePath="/courses/short-courses"
      />
    </div>
  );
};

export default ShortCoursesProgramsCard;
